import { BadgePosition, BalloonTheme } from '../../types'

export interface BalloonHintProps extends BalloonTheme {
  readonly parentHeight: number
  readonly parentOffset: number
  readonly position: BadgePosition
  readonly hintContents?: string | JSX.Element
}

export const PropDefaults = {
  bgColor: '#424242',
  className: undefined,
  fontColor: 'white',
  fontSize: '16px',
  margin: 8,
  hintContents: '',
  width: 230
}
